var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"competition-filter-modal",attrs:{"name":"competition-filter-modal","width":`50%`,"height":`50%`,"pivotY":0.5},on:{"before-close":_vm.handlerBeforeClose,"before-open":_vm.handlerBeforeOpen,"opened":_vm.handlerOpened}},[_c('div',[_vm._v(" 공모전 필터 모달 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }